import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { ReactSVG } from 'react-svg';
import CustomBtn from '../../generic/CustomBtn';
import slide1 from '../../assets/image/welcome/slide1.svg';
import slide2 from '../../assets/image/welcome/slide3.svg';
import slide3 from '../../assets/image/welcome/slide2.svg';
import slide4 from '../../assets/image/welcome/slide4.svg';

const sliderStepConfig = [
  {
    aboutStep: 'Welcome_to_OFP',
    image: slide1,
    title: 'welcome.title1',
    description: 'welcome.description1',
  },
  {
    aboutStep: 'OFP_and_NEAR',
    image: slide2,
    title: 'welcome.title2',
    description: 'welcome.description2',
  },
  {
    aboutStep: 'Stick_tight_to_your_NEAR_wallet',
    image: slide3,
    title: 'welcome.title3',
    description: 'welcome.description3',
  },
  {
    aboutStep: 'Lets_go',
    image: slide4,
    title: 'welcome.title4',
    description: 'welcome.description4',
  },
];

const WrapperStepRegistration = ({ children, step }) => {
  const stepInfo = sliderStepConfig[step];
  return (
    <>
      {children(stepInfo)}
      <div className="welcome__stepViewBlock">
        {sliderStepConfig.map((info, index) => <div key={info.aboutStep} className={`welcome__stepView ${step === index && 'active'}`} />)}
      </div>
    </>
  );
};

const StepRegistration = ({ image, title, description }) => (
  <>
    <ReactSVG
      src={image}
      className="welcome__image"
    />
    <FormattedMessage
      id={title}
      values={{
        h2: (...chunks) => <h2 className="welcome__title">{chunks}</h2>,
      }}
    />
    <FormattedMessage
      id={description}
      values={{
        p: (...chunks) => <p className="welcome__description">{chunks}</p>,
        bold: (chunks) => <b>{chunks}</b>,
        link: (...chunks) => <a href="mailto:support@openforestprotocol.org" className="welcome__contactUsEmail">{chunks}</a>,
        br: <br />,
      }}
    />
  </>
);

const WelcomePage = () => {
  const history = useHistory();
  const translate = useIntl();
  const [step, setStep] = useState(0);

  const changeStep = (val) => {
    if (val === 'next') {
      if (step === sliderStepConfig.length - 1) {
        history.push('/create-account');
        return null;
      }
      return setStep(step + 1);
    }
    if (val === 'prev') {
      return step === 0
        ? history.push('/login')
        : setStep(step - 1);
    }
    return null;
  };

  return (
    <>
      <WrapperStepRegistration step={step}>
        {(stepInfo) => <StepRegistration image={stepInfo.image} title={stepInfo.title} description={stepInfo.description} />}
      </WrapperStepRegistration>
      <div className="welcome__btnBlock">
        {step !== sliderStepConfig.length - 1 && (
          <CustomBtn
            label={translate.formatMessage({ id: 'button-back' })}
            type="button"
            customClass="btn__btn-prev"
            handleClick={() => changeStep('prev')}
          />
        )}
        <CustomBtn
          label={translate.formatMessage(step === sliderStepConfig.length - 1 ? { id: 'welcome.crtWallet' } : { id: 'button-next' })}
          type="button"
          customClass="btn__btn-next"
          handleClick={() => changeStep('next')}
        />
      </div>
    </>
  );
};

export default WelcomePage;
